import React, { useState } from 'react';

function FormSelect() {
  const params = new URLSearchParams(window.location.search);
  const town = params.get('town');
  const townCode = params.get('town_code');

  const [formType, setFormType] = useState('');

  const handleContinue = () => {
    if (!formType) return;
    if (formType === 'excise_abatement') {
      window.location.href = `/excise-abatement?town=${town}&town_code=${townCode}`;
    } else {
      window.location.href = `/login?town=${town}&town_code=${townCode}&form_type=${formType}`;
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAtownforms</h1>
        <p style={styles.meta}>{town}</p>
        <h2 style={styles.subtitle}>What are you filing?</h2>

        <div
          style={formType === 'form_2' ? styles.optionSelected : styles.option}
          onClick={() => setFormType('form_2')}
        >
          <p style={styles.optionTitle}>Form 2 — Business Owner</p>
          <p style={styles.optionDesc}>For businesses, corporations, LLCs, partnerships, and sole proprietors with personal property in {town}.</p>
        </div>

        <div
          style={formType === 'form_2hf' ? styles.optionSelected : styles.option}
          onClick={() => setFormType('form_2hf')}
        >
          <p style={styles.optionTitle}>Form 2HF — Second Home Owner</p>
          <p style={styles.optionDesc}>For individuals with household furnishings at a second residence in {town} that is not their primary home.</p>
        </div>
        <div
          style={formType === 'excise_abatement' ? styles.optionSelected : styles.option}
          onClick={() => setFormType('excise_abatement')}
        >
          <p style={styles.optionTitle}>Motor Vehicle Excise Abatement</p>
          <p style={styles.optionDesc}>Apply for a pro-rated refund of your motor vehicle excise tax if your vehicle was sold, traded, stolen, totaled, junked, repossessed, or moved out of state.</p>
        </div>
        <button
          style={formType ? styles.button : styles.buttonDisabled}
          onClick={handleContinue}
          disabled={!formType}
        >
          Continue
        </button>

        <p style={styles.backLink}>
          <a href="/" style={styles.anchor}>← Back</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '480px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '22px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  meta: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '16px',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  option: {
    border: '1px solid #ccc',
    borderRadius: '6px',
    padding: '16px',
    marginBottom: '12px',
    cursor: 'pointer',
  },
  optionSelected: {
    border: '2px solid #1a3a5c',
    borderRadius: '6px',
    padding: '16px',
    marginBottom: '12px',
    cursor: 'pointer',
    backgroundColor: '#f0f4f8',
  },
  optionTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#1a3a5c',
    marginBottom: '6px',
  },
  optionDesc: {
    fontSize: '13px',
    color: '#666',
    lineHeight: '1.5',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
    marginBottom: '16px',
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#aaa',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'not-allowed',
    marginTop: '8px',
    marginBottom: '16px',
  },
  backLink: {
    textAlign: 'center',
    fontSize: '14px',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
};

export default FormSelect;